export default __webpack_public_path__ + "static/media/portadavideoseguimiento1.e02de631.png";